import {
    apiRequest,
    create
} from "../../../../../services/adapters/kepegawaian/pengajuanOnlineService"

class CreateRepository {
    
    fetchCreate = async (query) => {
        return await apiRequest("post", create, {
            body: query
        }, true)
    }


}

export default CreateRepository